import React from 'react';
import {ContentWrapper, TextWrapper} from './Valid.style';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface ValidProps {
    readonly message: string;
    readonly isValid: boolean;
}

/**
 * @name Valid
 * @description
 * Component per validation of other components
 * The component is entirely agnostic. Validation functions and localization of the messages must be donne into the child components(consumers).
 */
export const Valid: React.FC<ValidProps> = (props) => {
    return (
        <ContentWrapper id={generateIdentifier()}>
            {(!props.isValid) && <TextWrapper id={generateIdentifier()}>{props.message}</TextWrapper>}
            {props.children}
        </ContentWrapper>
    );
};
